import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { subscriptionService } from "@/api/services";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "@phosphor-icons/react";

export default function SubscriptionCallback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const { refresh } = useAuth();
    const [status, setStatus] = useState("verifying"); // verifying | success | failed

    useEffect(() => {
        const reference = params.get("reference") || params.get("trxref");
        if (!reference) {
            setStatus("failed");
            return;
        }
        const verify = async () => {
            try {
                const res = await subscriptionService.verify(reference);
                if (res?.status === "success") {
                    await refresh().catch(() => {});
                    setStatus("success");
                } else {
                    setStatus("failed");
                }
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error("Verify failed:", err?.message || err);
                setStatus("failed");
            }
        };
        verify();
    }, [params, refresh]);

    return (
        <Layout withFooter={false}>
            <Seo title="Payment" path="/subscription/callback" noIndex />
            <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4">
                <div className="text-center max-w-md">
                    {status === "verifying" && (
                        <p className="font-mono text-sm uppercase tracking-widest text-zinc-400 pulse-sharp">
                            VERIFYING PAYMENT...
                        </p>
                    )}
                    {status === "success" && (
                        <>
                            <CheckCircle size={56} weight="fill" className="text-primary mx-auto mb-4" />
                            <h1 className="text-3xl font-black uppercase tracking-tighter mb-3">
                                Welcome to VIP
                            </h1>
                            <p className="text-zinc-400 mb-6">
                                Your subscription is active. Enjoy the full slip.
                            </p>
                            <Button
                                onClick={() => navigate("/dashboard")}
                                className="rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider"
                                data-testid="payment-success-dashboard-btn"
                            >
                                Go to Dashboard
                            </Button>
                        </>
                    )}
                    {status === "failed" && (
                        <>
                            <XCircle size={56} weight="fill" className="text-red-500 mx-auto mb-4" />
                            <h1 className="text-3xl font-black uppercase tracking-tighter mb-3">
                                Payment failed
                            </h1>
                            <p className="text-zinc-400 mb-6">
                                We couldn't verify your transaction. No charge was made.
                            </p>
                            <Button
                                onClick={() => navigate("/subscription")}
                                className="rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider"
                            >
                                Try again
                            </Button>
                        </>
                    )}
                </div>
            </div>
        </Layout>
    );
}
